import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from "src/app/components/sidebar/sidebar.component";
import { getMenuItems } from '../panel.utils';
import { AccessMenuItem } from 'src/app/interfaces/users/access.interface';

@Component({
  selector: 'app-panel',
  standalone: true,
  imports: [
    RouterOutlet,
    SidebarComponent
  ],
  templateUrl: './panel.component.html',
  styleUrl: './panel.component.scss'
})
export class PanelComponent {
  menuItems: AccessMenuItem[] = getMenuItems();
}
